<template>
  <div>
    <div class="row" id="audiogramaRef" ref="grafico">
      <svg
        version="1.2"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        aria-labelledby="title"
        role="img"
        :style="styleAudiograma"
        id="svgLinha"
      >
        <title id="title">Audiograma</title>
        <g
          class="grid x-grid"
          id="xGrid"
          style="stroke: #ccc; stroke-dasharray: 0; stroke-width: 1"
        >
          <line
            :x1="100 + index * ((largura - 100) / 9)"
            :x2="100 + index * ((largura - 100) / 9)"
            :y1="10"
            :y2="altura - 90"
            :stroke="index == 0 ? 'black' : 'lightgray'"
            v-for="(n, index) in 9"
            :key="index"
          ></line>
           <line
            :x1="largura - 19"
            :x2="largura - 19"
            :y1="10"
            :y2="altura - 90"
            stroke="lightgray"
          ></line>
        </g>
        <g
          class="grid y-grid"
          id="yGrid"
          style="stroke: #ccc; stroke-dasharray: 0; stroke-width: 1"
        >
          <line
            :x1="100"
            :x2="largura - 20"
            :y1="10 + index * ((altura - 100) / 15)"
            :y2="10 + index * ((altura - 100) / 15)"
            :stroke="index == 15 ? 'black' : 'lightgray'"
            v-for="(n, index) in 16"
            :key="index"
          ></line>
        </g>
        <g class="labels x-labels" style="text-anchor: middle; font-size: 13px">
          <text :x="100 + 1 * ((largura - 100) / 9)" :y="altura - 75">250</text>
          <text :x="100 + 2 * ((largura - 100) / 9)" :y="altura - 75">500</text>
          <text :x="100 + 3 * ((largura - 100) / 9)" :y="altura - 75">1000</text>
          <text :x="100 + 4 * ((largura - 100) / 9)" :y="altura - 75">
            2000
          </text>
          <text :x="100 + 5 * ((largura - 100) / 9)" :y="altura - 75">
            3000
          </text>
          <text :x="100 + 6 * ((largura - 100) / 9)" :y="altura - 75">
            4000
          </text>
          <text :x="100 + 7 * ((largura - 100) / 9)" :y="altura - 75">
            6000
          </text>
          <text :x="100 + 8 * ((largura - 100) / 9)" :y="altura - 75">
            8000
          </text>
          <text :x="100 + (largura - 100) / 2" :y="altura - 55">Hz</text>
        </g>
        <g class="labels y-labels" style="text-anchor: end; font-size: 13px">
          <text x="85" :y="15 + 1 * ((altura - 100) / 15)">-10</text>
          <text x="85" :y="15 + 2 * ((altura - 100) / 15)">0</text>
          <text x="85" :y="15 + 3 * ((altura - 100) / 15)">10</text>
          <text x="85" :y="15 + 4 * ((altura - 100) / 15)">20</text>
          <text x="85" :y="15 + 5 * ((altura - 100) / 15)">30</text>
          <text x="85" :y="15 + 6 * ((altura - 100) / 15)">40</text>
          <text x="85" :y="15 + 7 * ((altura - 100) / 15)">50</text>
          <text x="85" :y="15 + 8 * ((altura - 100) / 15)">60</text>
          <text x="85" :y="15 + 9 * ((altura - 100) / 15)">70</text>
          <text x="85" :y="15 + 10 * ((altura - 100) / 15)">80</text>
          <text x="85" :y="15 + 11 * ((altura - 100) / 15)">90</text>
          <text x="85" :y="15 + 12 * ((altura - 100) / 15)">100</text>
          <text x="85" :y="15 + 13 * ((altura - 100) / 15)">110</text>
          <text x="85" :y="15 + 14 * ((altura - 100) / 15)">120</text>
          <text x="50" :y="(altura - 100) / 2">dB</text>
        </g>
        <template v-for="(audiograma, index1) in dados">
          <g class="data" data-setname="Ouvido Direito" :key="index1">
            <template v-for="(item, index2) in audiograma.valores">
              <template v-if="audiograma.valores[index2].valor != null">
                <!-- AEREA -->
                <template v-if="audiograma.tipo == 'aerea'">

                  <!-- LINHAS -->
                  <line
                    v-if="
                      index2 + 1 <= audiograma.valores.length - 1 &&
                      audiograma.valores[index2 + 1].valor != null &&
                      audiograma.valores[index2].valor != null &&
                      (audiograma.valores[index2].ausente == false && audiograma.valores[index2 + 1].ausente == false)
                    "
                    :x1="calcularX(item.frequencia)"
                    :y1="calcularY(item.valor)"
                    :x2="calcularX(audiograma.valores[index2 + 1].frequencia)"
                    :y2="calcularY(audiograma.valores[index2 + 1].valor)"
                    :stroke="audiograma.ouvido == 'direito' ? 'red' : 'blue'"
                    :stroke-dasharray="audiograma.ouvido == 'direito' ? '' : '4,4'"
                    stroke-width="1"
                    :key="'linha1' + index1 + index2"
                  />

                  <!-- POSSUI VALOR  -->
                  <template v-if="!item.ausente">
                    <!-- MASCARA -->
                    <template v-if="item.mascara">
                      <!-- ouvido DIREITO -->
                      <template v-if="audiograma.ouvido == 'direito'">
                        <!-- Triangulo vermelho -->
                        <line
                          :x1="calcularX(item.frequencia) - 7"
                          :y1="calcularY(item.valor) + 5"
                          :x2="calcularX(item.frequencia) + 7"
                          :y2="calcularY(item.valor) + 5"
                          stroke="red"
                          stroke-width="2"
                          :key="'d1' + index1 + index2"
                        />
                        <line
                          :x1="calcularX(item.frequencia) - 7"
                          :y1="calcularY(item.valor) + 5"
                          :x2="calcularX(item.frequencia)"
                          :y2="calcularY(item.valor) - 7"
                          stroke="red"
                          stroke-width="2"
                          :key="'d2' + index1 + index2"
                        />
                        <line
                          :x1="calcularX(item.frequencia) + 7"
                          :y1="calcularY(item.valor) + 5"
                          :x2="calcularX(item.frequencia)"
                          :y2="calcularY(item.valor) - 7"
                          stroke="red"
                          stroke-width="2"
                          :key="'d3' + index1 + index2"
                        />
                      </template>

                      <!-- ouvido ESQUERDO -->
                      <template v-else>
                        <!-- Quadrado azul -->
                        <line
                          :x1="calcularX(item.frequencia) - 7"
                          :y1="calcularY(item.valor) + 5"
                          :x2="calcularX(item.frequencia) + 7"
                          :y2="calcularY(item.valor) + 5"
                          stroke="blue"
                          stroke-width="2"
                          :key="'d1' + index1 + index2"
                        />
                        <line
                          :x1="calcularX(item.frequencia) - 7"
                          :y1="calcularY(item.valor) + 5"
                          :x2="calcularX(item.frequencia) - 7"
                          :y2="calcularY(item.valor) - 7"
                          stroke="blue"
                          stroke-width="2"
                          :key="'d2' + index1 + index2"
                        />
                        <line
                          :x1="calcularX(item.frequencia) - 7"
                          :y1="calcularY(item.valor) - 7"
                          :x2="calcularX(item.frequencia) + 7"
                          :y2="calcularY(item.valor) - 7"
                          stroke="blue"
                          stroke-width="2"
                          :key="'d3' + index1 + index2"
                        />
                        <line
                          :x1="calcularX(item.frequencia) + 7"
                          :y1="calcularY(item.valor) + 5"
                          :x2="calcularX(item.frequencia) + 7"
                          :y2="calcularY(item.valor) - 7"
                          stroke="blue"
                          stroke-width="2"
                          :key="'d4' + index1 + index2"
                        />
                      </template>
                    </template>

                    <!-- SEM MASCARA -->
                    <template v-else>
                      <!-- ouvido DIREITO -->
                      <template v-if="audiograma.ouvido == 'direito'">
                        <!-- Circulo vermelho -->
                        <circle
                          :cx="calcularX(item.frequencia)"
                          :cy="calcularY(item.valor)"
                          r="7"
                          stroke="red"
                          stroke-width="2"
                          fill-opacity="0"
                          :key="'d1' + index1 + index2"
                        />
                      </template>

                      <!-- ouvido ESQUERDO -->
                      <template v-else>
                        <!-- X azul -->
                        <line
                          :x1="calcularX(item.frequencia) - 7"
                          :y1="calcularY(item.valor) + 5"
                          :x2="calcularX(item.frequencia) + 7"
                          :y2="calcularY(item.valor) - 7"
                          stroke="blue"
                          stroke-width="2"
                          :key="'d1' + index1 + index2"
                        />
                        <line
                          :x1="calcularX(item.frequencia) + 7"
                          :y1="calcularY(item.valor) + 5"
                          :x2="calcularX(item.frequencia) - 7"
                          :y2="calcularY(item.valor) - 7"
                          stroke="blue"
                          stroke-width="2"
                          :key="'d2' + index1 + index2"
                        />
                      </template>
                    </template>
                  </template>

                  <!-- AUSENCIA DE VALOR -->
                  <template v-if="item.ausente">
                    <!-- MASCARA -->
                    <template v-if="item.mascara">
                      <!-- ouvido DIREITO -->
                      <template v-if="audiograma.ouvido == 'direito'">
                        <!-- Triangulo vermelho com seta-->
                        <line
                          :x1="calcularX(item.frequencia) - 7"
                          :y1="calcularY(item.valor) + 5"
                          :x2="calcularX(item.frequencia) + 7"
                          :y2="calcularY(item.valor) + 5"
                          stroke="red"
                          stroke-width="2"
                          :key="'d1' + index1 + index2"
                        />
                        <line
                          :x1="calcularX(item.frequencia) - 7"
                          :y1="calcularY(item.valor) + 5"
                          :x2="calcularX(item.frequencia)"
                          :y2="calcularY(item.valor) - 7"
                          stroke="red"
                          stroke-width="2"
                          :key="'d2' + index1 + index2"
                        />
                        <line
                          :x1="calcularX(item.frequencia) + 7"
                          :y1="calcularY(item.valor) + 5"
                          :x2="calcularX(item.frequencia)"
                          :y2="calcularY(item.valor) - 7"
                          stroke="red"
                          stroke-width="2"
                          :key="'d3' + index1 + index2"
                        />

                        <!-- seta -->
                        <line
                          :x1="calcularX(item.frequencia) - 0"
                          :y1="calcularY(item.valor) + 5"
                          :x2="calcularX(item.frequencia) - 0"
                          :y2="calcularY(item.valor) + 16"
                          stroke="red"
                          stroke-width="2"
                          :key="'seta1' + index1 + index2"
                        />
                        <line
                          :x1="calcularX(item.frequencia) - 0"
                          :y1="calcularY(item.valor) + 18"
                          :x2="calcularX(item.frequencia) - 6"
                          :y2="calcularY(item.valor) + 11"
                          stroke="red"
                          stroke-width="2"
                          :key="'seta2' + index1 + index2"
                        />
                        <line
                          :x1="calcularX(item.frequencia) - 0"
                          :y1="calcularY(item.valor) + 18"
                          :x2="calcularX(item.frequencia) + 6"
                          :y2="calcularY(item.valor) + 11"
                          stroke="red"
                          stroke-width="2"
                          :key="'serta3' + index1 + index2"
                        />

                      </template>

                      <!-- ouvido Esquerdo -->
                      <template v-else>
                        <!-- Quadrado azul com seta -->
                        <line
                          :x1="calcularX(item.frequencia) - 7"
                          :y1="calcularY(item.valor) + 5"
                          :x2="calcularX(item.frequencia) + 7"
                          :y2="calcularY(item.valor) + 5"
                          stroke="blue"
                          stroke-width="2"
                          :key="'d1' + index1 + index2"
                        />
                        <line
                          :x1="calcularX(item.frequencia) - 7"
                          :y1="calcularY(item.valor) + 5"
                          :x2="calcularX(item.frequencia) - 7"
                          :y2="calcularY(item.valor) - 7"
                          stroke="blue"
                          stroke-width="2"
                          :key="'d2' + index1 + index2"
                        />
                        <line
                          :x1="calcularX(item.frequencia) - 7"
                          :y1="calcularY(item.valor) - 7"
                          :x2="calcularX(item.frequencia) + 7"
                          :y2="calcularY(item.valor) - 7"
                          stroke="blue"
                          stroke-width="2"
                          :key="'d3' + index1 + index2"
                        />
                        <line
                          :x1="calcularX(item.frequencia) + 7"
                          :y1="calcularY(item.valor) + 5"
                          :x2="calcularX(item.frequencia) + 7"
                          :y2="calcularY(item.valor) - 7"
                          stroke="blue"
                          stroke-width="2"
                          :key="'d4' + index1 + index2"
                        />

                        <!-- seta -->
                        <line
                          :x1="calcularX(item.frequencia) - 0"
                          :y1="calcularY(item.valor) + 5"
                          :x2="calcularX(item.frequencia) - 0"
                          :y2="calcularY(item.valor) + 16"
                          stroke="blue"
                          stroke-width="2"
                          :key="'seta4' + index1 + index2"
                        />
                        <line
                          :x1="calcularX(item.frequencia) - 0"
                          :y1="calcularY(item.valor) + 18"
                          :x2="calcularX(item.frequencia) - 6"
                          :y2="calcularY(item.valor) + 11"
                          stroke="blue"
                          stroke-width="2"
                          :key="'seta5' + index1 + index2"
                        />
                        <line
                          :x1="calcularX(item.frequencia) - 0"
                          :y1="calcularY(item.valor) + 18"
                          :x2="calcularX(item.frequencia) + 6"
                          :y2="calcularY(item.valor) + 11"
                          stroke="blue"
                          stroke-width="2"
                          :key="'seta6' + index1 + index2"
                        />

                      </template>
                    </template>

                    <!-- SEM MASCARA -->
                    <template v-else>
                      <!-- ouvido DIREITO -->
                      <template v-if="audiograma.ouvido == 'direito'">
                        <!-- Circulo vermelho com seta -->
                        <circle
                          :cx="calcularX(item.frequencia)"
                          :cy="calcularY(item.valor)"
                          r="7"
                          stroke="red"
                          stroke-width="2"
                          fill-opacity="0"
                          :key="'d1' + index1 + index2"
                        />

                        <!-- seta -->
                        <line
                          :x1="calcularX(item.frequencia) - 0"
                          :y1="calcularY(item.valor) + 5"
                          :x2="calcularX(item.frequencia) - 0"
                          :y2="calcularY(item.valor) + 16"
                          stroke="red"
                          stroke-width="2"
                          :key="'seta7' + index1 + index2"
                        />
                        <line
                          :x1="calcularX(item.frequencia) - 0"
                          :y1="calcularY(item.valor) + 18"
                          :x2="calcularX(item.frequencia) - 6"
                          :y2="calcularY(item.valor) + 11"
                          stroke="red"
                          stroke-width="2"
                          :key="'seta8' + index1 + index2"
                        />
                        <line
                          :x1="calcularX(item.frequencia) - 0"
                          :y1="calcularY(item.valor) + 18"
                          :x2="calcularX(item.frequencia) + 6"
                          :y2="calcularY(item.valor) + 11"
                          stroke="red"
                          stroke-width="2"
                          :key="'seta9' + index1 + index2"
                        />
                      </template>

                      <!-- SEM MASCARA -->
                      <template v-else>
                        <!-- X azul -->
                        <line
                          :x1="calcularX(item.frequencia) - 7"
                          :y1="calcularY(item.valor) + 5"
                          :x2="calcularX(item.frequencia) + 7"
                          :y2="calcularY(item.valor) - 7"
                          stroke="blue"
                          stroke-width="2"
                          :key="'d1' + index1 + index2"
                        />
                        <line
                          :x1="calcularX(item.frequencia) + 7"
                          :y1="calcularY(item.valor) + 5"
                          :x2="calcularX(item.frequencia) - 7"
                          :y2="calcularY(item.valor) - 7"
                          stroke="blue"
                          stroke-width="2"
                          :key="'d2' + index1 + index2"
                        />

                        <!-- seta -->
                        <line
                          :x1="calcularX(item.frequencia) - 0"
                          :y1="calcularY(item.valor) + 5"
                          :x2="calcularX(item.frequencia) - 0"
                          :y2="calcularY(item.valor) + 16"
                          stroke="blue"
                          stroke-width="2"
                          :key="'seta10' + index1 + index2"
                        />
                        <line
                          :x1="calcularX(item.frequencia) - 0"
                          :y1="calcularY(item.valor) + 18"
                          :x2="calcularX(item.frequencia) - 6"
                          :y2="calcularY(item.valor) + 11"
                          stroke="blue"
                          stroke-width="2"
                          :key="'seta11' + index1 + index2"
                        />
                        <line
                          :x1="calcularX(item.frequencia) - 0"
                          :y1="calcularY(item.valor) + 18"
                          :x2="calcularX(item.frequencia) + 6"
                          :y2="calcularY(item.valor) + 11"
                          stroke="blue"
                          stroke-width="2"
                          :key="'seta12' + index1 + index2"
                        />

                      </template>
                    </template>
                  </template>

                </template>

                <!-- OSSEA -->
                <template v-else-if="audiograma.tipo == 'ossea'">
                  <!-- POSSUI VALOR  -->
                  <template v-if="!item.ausente">
                    <!-- MASCARA -->
                    <template v-if="item.mascara">
                      <!-- ouvido DIREITO -->
                      <template v-if="audiograma.ouvido == 'direito'">
                        <text
                          :x="calcularX(item.frequencia) - 15"
                          :y="calcularY(item.valor) + 4"
                          :key="'d1' + index1 + index2"
                          stroke="red"
                          style="font-size: 20px"
                        >
                          [
                        </text>
                      </template>
                      <!-- ouvido ESQUERDO -->
                      <template v-else>
                        <text
                          :x="calcularX(item.frequencia) + 15"
                          :y="calcularY(item.valor) + 4"
                          :key="'d1' + index1 + index2"
                          stroke="blue"
                          style="font-size: 20px"
                        >
                          ]
                        </text>
                      </template>
                    </template>

                    <!-- SEM MASCARA -->
                    <template v-else>
                      <!-- ouvido DIREITO -->
                      <template v-if="audiograma.ouvido == 'direito'">
                        <line
                          :x1="calcularX(item.frequencia) - 17"
                          :y1="calcularY(item.valor)"
                          :x2="calcularX(item.frequencia) - 7"
                          :y2="calcularY(item.valor) + 10"
                          stroke="red"
                          stroke-width="2"
                          :key="'d1' + index1 + index2"
                        />
                        <line
                          :x1="calcularX(item.frequencia) - 17"
                          :y1="calcularY(item.valor)"
                          :x2="calcularX(item.frequencia) - 7"
                          :y2="calcularY(item.valor) - 10"
                          stroke="red"
                          stroke-width="2"
                          :key="'d2' + index1 + index2"
                        />
                      </template>
                      <!-- ouvido ESQUERDO -->
                      <template v-else>
                        <line
                          :x1="calcularX(item.frequencia) + 17"
                          :y1="calcularY(item.valor)"
                          :x2="calcularX(item.frequencia) + 7"
                          :y2="calcularY(item.valor) + 10"
                          stroke="blue"
                          stroke-width="2"
                          :key="'d1' + index1 + index2"
                        />
                        <line
                          :x1="calcularX(item.frequencia) + 17"
                          :y1="calcularY(item.valor)"
                          :x2="calcularX(item.frequencia) + 7"
                          :y2="calcularY(item.valor) - 10"
                          stroke="blue"
                          stroke-width="2"
                          :key="'d2' + index1 + index2"
                        />
                      </template>
                    </template>
                  </template>

                  <!-- AUSENCIA DE VALOR -->
                  <template v-else>
                    <!-- MASCARA -->
                    <template v-if="item.mascara">
                      <!-- ouvido DIREITO -->
                      <template v-if="audiograma.ouvido == 'direito'">
                        <text
                          :x="calcularX(item.frequencia) - 15"
                          :y="calcularY(item.valor) + 4"
                          :key="'d1' + index1 + index2"
                          stroke="red"
                          style="font-size: 20px"
                        >
                          [
                        </text>

                        <!-- seta -->
                        <line
                          :x1="calcularX(item.frequencia) - 0 - 8"
                          :y1="calcularY(item.valor) + 5"
                          :x2="calcularX(item.frequencia) - 0 - 8"
                          :y2="calcularY(item.valor) + 16"
                          stroke="red"
                          stroke-width="2"
                          :key="'seta13' + index1 + index2"
                        />
                        <line
                          :x1="calcularX(item.frequencia) - 0 - 8"
                          :y1="calcularY(item.valor) + 18"
                          :x2="calcularX(item.frequencia) - 6 - 8"
                          :y2="calcularY(item.valor) + 11"
                          stroke="red"
                          stroke-width="2"
                          :key="'seta14' + index1 + index2"
                        />
                        <line
                          :x1="calcularX(item.frequencia) - 0 - 8"
                          :y1="calcularY(item.valor) + 18"
                          :x2="calcularX(item.frequencia) + 6 - 8"
                          :y2="calcularY(item.valor) + 11"
                          stroke="red"
                          stroke-width="2"
                          :key="'seta15' + index1 + index2"
                        />

                      </template>
                      <!-- ouvido ESQUERDO -->
                      <template v-else>
                        <text
                          :x="calcularX(item.frequencia) + 15"
                          :y="calcularY(item.valor) + 4"
                          :key="'d1' + index1 + index2"
                          stroke="blue"
                          style="font-size: 20px"
                        >
                          ]
                        </text>

                        <!-- seta -->
                        <line
                          :x1="calcularX(item.frequencia) - 0 + 21"
                          :y1="calcularY(item.valor) + 5"
                          :x2="calcularX(item.frequencia) - 0 + 21"
                          :y2="calcularY(item.valor) + 16"
                          stroke="blue"
                          stroke-width="2"
                          :key="'seta16' + index1 + index2"
                        />
                        <line
                          :x1="calcularX(item.frequencia) - 0 + 21"
                          :y1="calcularY(item.valor) + 18"
                          :x2="calcularX(item.frequencia) - 6 + 21"
                          :y2="calcularY(item.valor) + 11"
                          stroke="blue"
                          stroke-width="2"
                          :key="'seta17' + index1 + index2"
                        />
                        <line
                          :x1="calcularX(item.frequencia) - 0 + 21"
                          :y1="calcularY(item.valor) + 18"
                          :x2="calcularX(item.frequencia) + 6 + 21"
                          :y2="calcularY(item.valor) + 11"
                          stroke="blue"
                          stroke-width="2"
                          :key="'seta18' + index1 + index2"
                        />

                      </template>
                    </template>

                    <!-- SEM MASCARA -->
                    <template v-else>
                      <!-- ouvido DIREITO -->
                      <template v-if="audiograma.ouvido == 'direito'">
                        <line
                          :x1="calcularX(item.frequencia) - 17"
                          :y1="calcularY(item.valor)"
                          :x2="calcularX(item.frequencia) - 7"
                          :y2="calcularY(item.valor) + 10"
                          stroke="red"
                          stroke-width="2"
                          :key="'d1' + index1 + index2"
                        />
                        <line
                          :x1="calcularX(item.frequencia) - 17"
                          :y1="calcularY(item.valor)"
                          :x2="calcularX(item.frequencia) - 7"
                          :y2="calcularY(item.valor) - 10"
                          stroke="red"
                          stroke-width="2"
                          :key="'d2' + index1 + index2"
                        />

                        <!-- seta -->
                        <line
                          :x1="calcularX(item.frequencia) - 0 - 8"
                          :y1="calcularY(item.valor) + 5 + 5"
                          :x2="calcularX(item.frequencia) - 0 - 8"
                          :y2="calcularY(item.valor) + 16 + 5"
                          stroke="red"
                          stroke-width="2"
                          :key="'seta19' + index1 + index2"
                        />
                        <line
                          :x1="calcularX(item.frequencia) - 0 - 8"
                          :y1="calcularY(item.valor) + 18 + 5"
                          :x2="calcularX(item.frequencia) - 6 - 8"
                          :y2="calcularY(item.valor) + 11 + 5"
                          stroke="red"
                          stroke-width="2"
                          :key="'seta20' + index1 + index2"
                        />
                        <line
                          :x1="calcularX(item.frequencia) - 0 - 8"
                          :y1="calcularY(item.valor) + 18 + 5"
                          :x2="calcularX(item.frequencia) + 6 - 8"
                          :y2="calcularY(item.valor) + 11 + 5"
                          stroke="red"
                          stroke-width="2"
                          :key="'seta21' + index1 + index2"
                        />


                      </template>
                      <!-- ouvido ESQUERDO -->
                      <template v-else>
                        <line
                          :x1="calcularX(item.frequencia) + 17"
                          :y1="calcularY(item.valor)"
                          :x2="calcularX(item.frequencia) + 7"
                          :y2="calcularY(item.valor) + 10"
                          stroke="blue"
                          stroke-width="2"
                          :key="'d1' + index1 + index2"
                        />
                        <line
                          :x1="calcularX(item.frequencia) + 17"
                          :y1="calcularY(item.valor)"
                          :x2="calcularX(item.frequencia) + 7"
                          :y2="calcularY(item.valor) - 10"
                          stroke="blue"
                          stroke-width="2"
                          :key="'d2' + index1 + index2"
                        />
                                                
                        <!-- seta -->
                        <line
                          :x1="calcularX(item.frequencia) - 0 + 8"
                          :y1="calcularY(item.valor) + 5 + 5"
                          :x2="calcularX(item.frequencia) - 0 + 8"
                          :y2="calcularY(item.valor) + 16 + 5"
                          stroke="blue"
                          stroke-width="2"
                          :key="'seta22' + index1 + index2"
                        />
                        <line
                          :x1="calcularX(item.frequencia) - 0 + 8"
                          :y1="calcularY(item.valor) + 18 + 5"
                          :x2="calcularX(item.frequencia) - 6 + 8"
                          :y2="calcularY(item.valor) + 11 + 5"
                          stroke="blue"
                          stroke-width="2"
                          :key="'seta23' + index1 + index2"
                        />
                        <line
                          :x1="calcularX(item.frequencia) - 0 + 8"
                          :y1="calcularY(item.valor) + 18 + 5"
                          :x2="calcularX(item.frequencia) + 6 + 8"
                          :y2="calcularY(item.valor) + 11 + 5"
                          stroke="blue"
                          stroke-width="2"
                          :key="'seta24' + index1 + index2"
                        />

                      </template>
                    </template>
                  </template>
                </template>

                <!-- LIVRE (campo livre) -->
                <template v-else-if="audiograma.tipo == 'livre'">
                  <rect
                    :x="calcularX(item.frequencia) - 7"
                    :y="calcularY(item.valor) - 7"
                    width="14"
                    height="14"
                    stroke="black"
                    stroke-width="2"
                    fill="none"
                    :key="'livre' + index1 + index2"
                  />
                </template>

              </template>
            </template>
          </g>
        </template>
      </svg>
    </div>
  </div>
</template>

<script>
// import _ from 'lodash';

export default {
  data() {
    return {
      frequencias: [250, 500, 1000, 2000, 3000, 4000, 6000, 8000],
      resizeObj: null,
      largura: 800,
    };
  },
  props: {
    dados: { type: Array },
    // largura: { type: Number, default: 800 },
    altura: { type: Number, default: 500 },
  },
  computed: {
    styleAudiograma() {
      return "height: " + this.altura + "px; width: " + this.largura + "px";
    },
  },
  methods: {
    calcularX(fz) {
      const indexFrequencia = this.frequencias.findIndex((e) => e == fz);
      const valorX = 100 + (indexFrequencia + 1) * ((this.largura - 100) / 9);
      return valorX;
    },
    calcularY(db) {
      const indexVolume = this.findVolumeIndex(Number(db));
      const valorY = 10 + indexVolume * ((this.altura - 100) / 15);
      return valorY;
    },

    findVolumeIndex(value) {
      if (value == -20) return 0;
      if (value > -20 && value < -10) return 0.5;
      if (value == -10) return 1;
      if (value > -10 && value < 0) return 1.5;
      if (value == 0) return 2;
      if (value > 0 && value < 10) return 2.5;
      if (value == 10) return 3;
      if (value > 10 && value < 20) return 3.5;
      if (value == 20) return 4;
      if (value > 20 && value < 30) return 4.5;
      if (value == 30) return 5;
      if (value > 30 && value < 40) return 5.5;
      if (value == 40) return 6;
      if (value > 40 && value < 50) return 6.5;
      if (value == 50) return 7;
      if (value > 50 && value < 60) return 7.5;
      if (value == 60) return 8;
      if (value > 60 && value < 70) return 8.5;
      if (value == 70) return 9;
      if (value > 70 && value < 80) return 9.5;
      if (value == 80) return 10;
      if (value > 80 && value < 90) return 10.5;
      if (value == 90) return 11;
      if (value > 90 && value < 100) return 11.5;
      if (value == 100) return 12;
      if (value > 100 && value < 110) return 12.5;
      if (value == 110) return 13;
      if (value > 110 && value < 120) return 13.5;
      if (value == 120) return 14;

      if (value > 120) return 14.5;
    },

    onResize() {
      this.largura = this.$refs.grafico.clientWidth;
    },
  },
  mounted() {
    this.largura = this.$refs.grafico.clientWidth;

    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
};
</script>

<style>
</style>
